var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M23.0298 7.28056L20.2267 10.0837C19.6604 16.6481 14.1245 21.7499 7.49919 21.7499C6.13794 21.7499 5.01575 21.5343 4.16357 21.1087C3.47638 20.7646 3.19513 20.3962 3.12482 20.2912C3.06212 20.1972 3.02148 20.0902 3.00594 19.9782C2.9904 19.8663 3.00035 19.7523 3.03506 19.6448C3.06977 19.5372 3.12833 19.4389 3.20638 19.3572C3.28442 19.2754 3.37992 19.2124 3.48575 19.1727C3.51013 19.1634 5.75826 18.2999 7.18607 16.6565C6.39424 16.0055 5.70302 15.241 5.13482 14.3877C3.97232 12.6618 2.67107 9.66369 3.07232 5.18337C3.08504 5.04101 3.13817 4.90525 3.22546 4.79207C3.31275 4.67889 3.43057 4.59301 3.56503 4.54454C3.69949 4.49608 3.845 4.48704 3.98443 4.51851C4.12385 4.54997 4.25138 4.62061 4.352 4.72212C4.38482 4.75494 7.472 7.82525 11.2464 8.82087V8.24994C11.2449 7.65124 11.3633 7.05831 11.5945 6.50606C11.8257 5.95381 12.1651 5.45341 12.5926 5.03431C13.0078 4.61968 13.5019 4.29241 14.0457 4.07182C14.5894 3.85123 15.1718 3.74178 15.7586 3.74994C16.5457 3.7577 17.3173 3.96899 17.9986 4.36325C18.6799 4.75752 19.2475 5.32135 19.6464 5.99994H22.4992C22.6476 5.99982 22.7927 6.04374 22.9162 6.12615C23.0396 6.20855 23.1358 6.32573 23.1927 6.46284C23.2495 6.59996 23.2643 6.75085 23.2353 6.89642C23.2064 7.04198 23.1348 7.17567 23.0298 7.28056Z",
    fill: "#44546F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.8915300eedcbed4c12828ed9593d529c.svg";
export { ForwardRef as ReactComponent };